import type { Consumer } from "@rails/actioncable"

let consumer: Consumer | null = null

/** The shared Action Cable connection. Browser-only: never call it during render. */
export async function cableConsumer() {
  if (!consumer) {
    const { createConsumer } = await import("@rails/actioncable")
    consumer = createConsumer()
  }
  return consumer
}
